import createHttpInstance from "./http-common";

class CantFindLocation {

    private serviceName = '/PublicRequest';

    async updateLocationList(id: any, statusId: any, comments: string) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/UpdateOrderPublicRequest?id=${id}&statusId=${statusId}&comments=${comments}`).catch((err: Error) => {
            throw err?.message;
        })
    }
}

export default new CantFindLocation();